import React, { useEffect, useState } from 'react';
import { singleton, container } from "tsyringe";
import { Config } from "../config";
import { fetchAndGetArrayBuffer, fetchAndGetText, fetchAndThrowHttpErrors, fetchBinaryAndThrowHttpErrors } from "../utils/helpers";

import { BehaviorSubject } from 'rxjs';
import * as _ from 'lodash';
import { UserService } from './user-service';
import { VideoCms } from '../models/cmsVideoClass';

@singleton()
export class CmsManagementService {

  private endpointUrl = `${Config.BJ_SEAM_API}`;
  urlCms              = "/seamapi/v1/user/"; //  + window.BJN.User.id + "/cms/";
  urlGetUploadUrl     = "/get_upload_url/";
  urlGetUploadForm    = "/get_upload_form/";

  uploadFailed = "upload_failed";

  // https://bluejeans.com/get_upload_form/?method=PUT&fileName=2022+inFire.mp4&fileType=video%2Fmp4&browser=chrome&runtime=html5


  private userService: UserService = container.resolve(UserService);

  public videoList$ = new BehaviorSubject<VideoCms[]>(null);
  uploadVideoKey$ = new BehaviorSubject<string>(null);
  public uploadPercentage$: BehaviorSubject<number> = new BehaviorSubject<number>(0);

  private randomize() {
    // add random number to GET request to bypass cache
    return Math.floor(Math.random() * 100000000);
  }

  private sortByDate (a: VideoCms, b: VideoCms) {
    // more recent first
    return b.modified - a.modified;
  }

  public async getContentsVideo() {
    if (!this.userService.user) return;

    console.log('CMS getContentVideo');

    let headers = this.userService.addJWTAuthenticationHeader({})
    let uid = this.userService.user.id;

    const finalUrl = this.endpointUrl + this.urlCms + this.userService.user.id +
    '/cms/?contentCategory=VIDEO&access_token=' + this.userService.bjToken$.getValue() + '&_=' + this.randomize();

    fetchAndThrowHttpErrors(finalUrl, {
      headers: headers
    })

    .then((videos: VideoCms[]) => {
      console.log('loaded CMS videos', videos);
      this.videoList$.next(videos.sort(this.sortByDate));
    })
  }

  public async uploadFile(file: any) {

    if (!this.userService.jwtToken$.getValue()) {
      await new Promise(
        (f, r) => {
          setTimeout(_ => {
            f('');
          }, 3000)
        })
    }


    // Request presigned url :
    const finalUrl = this.endpointUrl + this.urlGetUploadForm + '?method=PUT&filename=' + file.name + '&fileType=' + file.type + '&browser=chrome&runtime=html5';

    await fetchAndThrowHttpErrors(finalUrl).then((presignedUrls: any) => {

      console.log('CMS presignedUrl', presignedUrls);

      /*
      form: {
        AWSAccessKeyId: "AKIA6AHP2WFMYJGIFZEK"
        Filename: "2022 inFire.mp4"
        acl: "private"
        key: "4913571/00e65c89-4c18-42e0-97e7-0a3a8a42a4f0.mp4"
        policy: "eyJleHBpcmF0aW9uIjogIjIwMjItMDEtMjJUMTU6Mjk6NDdaIiwiY29uZGl0aW9ucyI6IFt7ImJ1Y2tldCI6ImJqbi12aWRlb3NoYXJlLXByb2QifSxbImVxIiwiJGtleSIsIjQ5MTM1NzEvMDBlNjVjODktNGMxOC00MmUwLTk3ZTctMGEzYThhNDJhNGYwLm1wNCJdLHsiYWNsIjoicHJpdmF0ZSJ9LFsnc3RhcnRzLXdpdGgnLCckbmFtZScsJyddLFsnc3RhcnRzLXdpdGgnLCckRmlsZW5hbWUnLCcnXSx7IngtYW16LW1ldGEtY29udGVudF90eXBlIjoidmlkZW8vbXA0In0seyJ4LWFtei1tZXRhLWZpbGVfbmFtZSI6IjIwMjIgaW5GaXJlLm1wNCJ9LHsic3VjY2Vzc19hY3Rpb25fc3RhdHVzIjoiMjAwIn1dfQ=="
        signature: "ocPAg1ga3oKM7+5OgUSPlnS9pmg="
        success_action_status: 200
        x-amz-meta-content_type: "video/mp4"
        x-amz-meta-file_name: "2022 inFire.mp4"
      }
      newFileName: "00e65c89-4c18-42e0-97e7-0a3a8a42a4f0.mp4"
      uploadUrl: "//bjn-videoshare-prod.s3.amazonaws.com"
      */

      if (presignedUrls) {

        // no S3 in lab env ?!
        // if (presignedUrls.uploadUrl == '.s3.amazonaws.com') {
        //   presignedUrls.uploadUrl = '//bjn-videoshare-lab.s3.amazonaws.com';
        // }

        const formData = new FormData();
        for ( var key in presignedUrls.form ) {
          formData.append(key, presignedUrls.form[key]);
        }
        formData.append('file', file);

        fetchBinaryAndThrowHttpErrors(
          'POST',
          presignedUrls.uploadUrl,
          formData,
          // progress
          (percent) => {
            console.log('CMS percent', percent);

            if (percent < 100) {
              // keep 100 when upload is completed
              this.uploadPercentage$.next(percent);
            }
          },
          // completed
          () => {

            console.log('CMS upload completed');

            this.uploadPercentage$.next(100);
            localStorage.setItem('assetLastUploadDate', Date.now().toString());


            // link user and video
            const body = {
              contentCategory: "VIDEO",
              contentDescription: "",
              contentLocation: "S3",
              contentName: file.name,
              contentSize: file.size,
              contentType: file.type,
              contentUrl: this.userService.user.id + '/' + presignedUrls.newFileName,
            }

            const finalUrl = this.endpointUrl + this.urlCms + '/user/' + this.userService.user.id + '/cms/?access_token=' + this.userService.jwtToken$.getValue();

            fetchAndThrowHttpErrors(finalUrl, {
              method: 'POST',
              body: JSON.stringify(body),
              headers: this.userService.addJWTAuthenticationHeader({})
            })
            .then((videoId) => {
              console.log('CMS new video id', videoId);
              this.uploadVideoKey$.next(videoId.toString());
            }, (error) => {
              console.log('CMS error', error);
              this.uploadVideoKey$.next(this.uploadFailed);
            })


          },
          // error callback
          () => {
            console.log('CMS error gen');
            this.uploadVideoKey$.next(this.uploadFailed);
          }
        )
        .then(_ => {
        })
      } else {
        console.log('CMS unable to get presignedUrls');
        this.uploadVideoKey$.next(this.uploadFailed);
      }
    })
    return;
  }


  public async deleteVideo(videoId) {
    if (this.userService.user) {

      const finalUrl = this.endpointUrl + this.urlCms + this.userService.user.id + '/cms/'+ videoId + '?access_token=' + this.userService.bjToken$.getValue();

      fetchAndThrowHttpErrors(finalUrl, {
        method: 'DELETE',
      })
      .then(_ => {
      })
    }
  }

  stopCurrentVideo() {
  }


  // public async renameAsset(assetId: string, assetName: string) {
  //   // find asset
  //   const asset = this.assetList$.getValue().find(a => a.id === assetId);

  //   if (asset) {
  //     asset.title = assetName;
  //     const body = {
  //       title: assetName,
  //     }
  //     fetchAndThrowHttpErrors(`${this.endpointUrl}/dam/user/${this.userService.user.id}/assets/${assetId}`, {
  //       method: 'PUT',
  //       body: JSON.stringify(body),
  //       headers: this.userService.addJWTAuthenticationHeader({})
  //     })
  //     .then(_ => {
  //       // empty response returned by update
  //     }, (error) => {
  //       console.log('asset update failed ', error)
  //     })

  //   }
  // }

}